import React from 'react';
import { type IRootWidgetIdentifier } from '../../../tree/references/TreeReferencesGlobalContext.tsx';

interface IAllRootsContextValue {
  allRoots: IRootWidgetIdentifier[];
}

export const AllRootsContext = React.createContext<IAllRootsContextValue>({
  allRoots: [],
});

export interface IAllRootsContextProviderProps {
  allRoots: IRootWidgetIdentifier[];
  children: React.ReactNode;
}

export function AllRootsContextProvider(props: IAllRootsContextProviderProps) {
  const value = React.useMemo(
    () => ({ allRoots: props.allRoots }),
    [props.allRoots],
  );

  return (
    <AllRootsContext.Provider value={value}>
      {props.children}
    </AllRootsContext.Provider>
  );
}

export function useAllRootsContext() {
  const context = React.useContext(AllRootsContext);
  if (context == null) {
    // biome-ignore format: <tbd>
    throw new Error('useAllRootsContext must be used within an AllRootsContext');
  }
  return context;
}
